import React from 'react';
import { compose } from 'recompose';
import { Modal, Header, Icon, Button } from 'semantic-ui-react';
import { withLocale } from 'op/components/locale';

const ValidationSuccessModal = ({ locale, open, onClose }) => {
    return (
        <Modal open={open} onClose={onClose} basic size="small">
            <Header 
                icon="check circle" 
                content={locale.validationSuccessHeader}
                style={{ fontSize: '24px' }}
            />
            <Modal.Content>
                <div style={{ fontSize: '18px' }}>
                    {locale.allKPIsValid}
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color="green" inverted onClick={onClose}>
                    <Icon name="checkmark" /> {locale._system.close}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default compose(
    withLocale('stp.validation'),
)(ValidationSuccessModal); 